import { push } from 'connected-react-router';
import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import config from '../../../config.json'
import { eventSendMailRequest, eventUpdateRequest, uiRequestOverlayReset, uiSetRequestOverlayRequest, uiSetRequestOverlayType } from '../../../actions/index.js';
import { EVENT_DATA, EVENT_DATA_EVENTS, EVENT_DATA_SETTINGS, TRANSLATION, UI_GENERAL } from '../../../constants/state.js';
import toJS from '../../../containers/general/toJS.js';
import getData from '../../../functions/getData.js';
import PageEditEventPage from '../present/PageEditEventPage.jsx';
import { OVERLAY_EVENTS_MAIL_SEND, OVERLAY_EVENTS_MAIL_YES_NO, OVERLAY_EVENTS_UPDATE, OVERLAY_NEWSLETTER_SEND } from '../../../constants/overlayTypes.js';
import actionTypes from '../../../actions/actionTypes'

const mapStateToProps = (state, ownProps) => ({
    status: getData(state, [EVENT_DATA, 'events', 'status']),
    error: getData(state, [EVENT_DATA, 'events', 'error']),
    events: getData(state, [EVENT_DATA_EVENTS, 'items']),
    settings: getData(state, [EVENT_DATA_SETTINGS, 'items', ownProps.match.params.settingsId]),
    currentLang: state.getIn(['translation', 'currentLang']),
    timezone: state.getIn(['translation', 'timezone']),
    debug: state.getIn(['translation', 'debug']),
    uiRequestOverlay: getData(state, [UI_GENERAL, 'requestOverlay']),
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doUpdateEvent: (id, data) => {
        dispatch(eventUpdateRequest(id, data))
    },
    requestSendMail: (id) => {
        dispatch(uiSetRequestOverlayType(OVERLAY_EVENTS_MAIL_YES_NO))
        dispatch(uiSetRequestOverlayRequest(actionTypes.EVENTS_EVENTS_SEND_MAIL_REQUEST))
    }, 
    cancelRequestSendMail: () => {
        dispatch(uiRequestOverlayReset())
    },   
    sendMail: (id) => {
        dispatch(uiSetRequestOverlayType(OVERLAY_EVENTS_MAIL_SEND))
        dispatch(eventSendMailRequest(id))
    },
    onCancel: ()  => {
        dispatch(push(config.routes.events.path))
    },
})

const PageEditEvent = ({match, status, error, events, settings, currentLang, timezone, debug, doUpdateEvent, onCancel, requestSendMail, cancelRequestSendMail, sendMail, uiRequestOverlay}) => {
    const [displayOverlay, setDisplayOverlay] = useState(true)

    useEffect(() => {
        if(!displayOverlay) {
            setDisplayOverlay(true)
        }
    }, [status])


    const onUpdateEvent = (id, data) => {
        setDisplayOverlay(true)
        doUpdateEvent(id, data)
    }

    const onSendMail = (id) => {
        console.log("onSendMail", id)
        sendMail(id)
    }

    return <PageEditEventPage
        status={status}
        error={error}
        event={match ? events[match.params.eventId] : false}
        settings={settings}
        uiRequestOverlay={uiRequestOverlay}
        displayOverlay={displayOverlay}
        setDisplayOverlay={setDisplayOverlay}
        
        currentLang={currentLang}
        timezone={timezone}
        debug={debug}
        onUpdateEvent={onUpdateEvent}
        onRequestSendMail={requestSendMail}
        onCancelRequestSendMail={cancelRequestSendMail}
        onSendMail={onSendMail}
        onCancel={onCancel}
    />
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(PageEditEvent))